import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowLeft, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import PasswordInput from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { apiError } from "@/lib/format";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) return toast.error("As senhas não coincidem");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      toast.success("Senha redefinida! Faça login com a nova senha.");
      navigate("/login");
    } catch (err) { toast.error(apiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-ink text-white flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-slate-400 hover:text-white mb-6"><ArrowLeft className="w-4 h-4" /> Voltar ao login</Link>
        <div className="rounded-2xl bg-surface border border-white/10 p-8 animate-fade-up">
          <div className="flex items-center gap-3 mb-6"><KeyRound className="w-8 h-8 text-brand" /><h1 className="font-display text-2xl font-black uppercase">Nova senha</h1></div>
          {!token ? (
            <p className="text-slate-400 text-sm" data-testid="reset-no-token">Link inválido. Solicite a redefinição novamente pela tela de login.</p>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
              <div><Label className="text-slate-300">Nova senha</Label><PasswordInput testId="reset-password" minLength={6} required value={pwd} onChange={(e) => setPwd(e.target.value)} className="bg-ink border-white/10 mt-1" /></div>
              <div><Label className="text-slate-300">Confirmar senha</Label><PasswordInput testId="reset-password-confirm" minLength={6} required value={pwd2} onChange={(e) => setPwd2(e.target.value)} className="bg-ink border-white/10 mt-1" /></div>
              <Button data-testid="reset-submit-btn" type="submit" disabled={loading} className="w-full bg-brand hover:bg-brand-hover font-bold uppercase tracking-wide h-11">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salvar nova senha"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
